import { withStyles } from '@material-ui/core/styles';
import { LOG_LIST_TITLE } from '../../libraries/texts';
import service from '../../services/log-service';

import ListForm from '../maintainer/list';
import { MaintainerList as styles } from '../maintainer/styles';

export default withStyles(styles)(ListForm({ service, title: LOG_LIST_TITLE, name: 'LOG' }));
